export enum NotificationStatuses {
  New = "NEW",
  InProgress = "INPROGRESS",
  Completed = "COMPLETED",
  Archived = "ARCHIVED",
  Failed = "FAILED",
}
